import { FormSection, FormRow, BigFormRow, CreatePageLayout } from 'framework/ui/layout';
import { FormTemplate, DateInput, FormListTemplate } from 'framework/form';
import ExpenseForm from '../createupdate/ExpenseForm';
import { OFFICE, OFFICE_NAMES, OfficeDropdown } from 'domain/shared/employee';
import useUploadExpenses from './useUploadExpenses';
import UploadExpensesValidation from './UploadExpensesValidation';
import UploadExpenseBreadcrumbs from './UploadExpenseBreadcrumbs';
import { DATE_FORMAT } from 'framework/utils';
import { snakeCase } from 'lodash';
import { UploadInputWithoutArtifactID } from 'domain/shared/artifact/input';
import { useExpenseUrl } from 'domain/shared/expense';

const UploadExpensesPage = () => {
  const { getListUrl } = useExpenseUrl();
  const {
    uploadExpensesForms,
    additionalInfoCallback,
    getListExpenses,
    initialFormsListData,
    getValidationSchema: getEditValidationSchema,
  } = useUploadExpenses();

  const getValidationSchema = () => {
    return Promise.resolve(UploadExpensesValidation);
  };

  return initialFormsListData.length > 0 ? (
    <CreatePageLayout buttons={<></>} breadcrumbs={<UploadExpenseBreadcrumbs />} title="Upload worker expenses">
      <FormListTemplate
        // TODO use batch submit after backend is ready
        isBatchUpload={false}
        isBatchUploadBySize={false}
        isShowAdditionalInformation
        submitFormFunc={uploadExpensesForms}
        additionalInfoFunc={additionalInfoCallback}
        getValidationSchemaFunc={getEditValidationSchema}
        initialListData={initialFormsListData}
        afterSubmit={{
          message: 'You are awesome! Worker expenses have been successfully uploaded.',
          redirect: getListUrl(),
        }}
      >
        <ExpenseForm disabledOffice isNeedToUploadOfficeByEmployee={false} />
      </FormListTemplate>
    </CreatePageLayout>
  ) : (
    <FormTemplate
      initialData={{
        // TODO Now only KRAKOW_1
        office: OFFICE.KRAKOW_1,
      }}
      getValidationSchemaFunc={getValidationSchema}
      submitFormFunc={getListExpenses}
    >
      <CreatePageLayout breadcrumbs={<UploadExpenseBreadcrumbs />} title="Upload Worker Expenses">
        <FormSection>
          <FormRow>
            <DateInput label="Period" source="period" dateFormat={DATE_FORMAT.API_ONLY_MONTH} />
            <OfficeDropdown
              mapResults={(office: any) => ({
                value: snakeCase(office.name).toUpperCase(),
                label: OFFICE_NAMES[office.name],
              })}
              source="office"
              // TODO Now only KRAKOW_1
              disabled
            />
          </FormRow>

          <BigFormRow>
            <UploadInputWithoutArtifactID
              maxElements={1}
              label="File"
              source="file"
              formats="xls,xlsx"
              canAddFromClipboard={false}
            />
          </BigFormRow>
        </FormSection>
      </CreatePageLayout>
    </FormTemplate>
  );
};

export default UploadExpensesPage;
